module.exports = __webpack_public_path__ + "static/media/Album_b.035fd2e1.png";